import React, { useEffect, useState } from 'react';
import {
    Box,
    Paper,
    Typography,
    TextField,
    Button,
    IconButton,
    Avatar,
    CircularProgress,
    Grid2 as Grid,
    Snackbar,
    Alert,
    Grid2,
    Tabs,
    Tab,
} from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
// import { Actions } from '../Redux/Reducer/rootReducer';
// import { userEditSuccess, userError, userIsLoading } from '../Redux/selectors';
import LoadingOverlay from './LoadingOverlay';
import { useAuth } from '../../context/authContext';
import { currentUnit, userError, userIsLoading } from '../../Redux/selectors';
import { ContactEmergency, LockOpen, MeetingRoom, Person } from '@mui/icons-material';
import { Actions } from '../../Redux/Reducer/rootReducer';
import { Unit, User } from '../../Types/UnitFeatureTypes';
import UserCard from './UserCard';
// import { deleteImage, uploadImage, uploadMultipleImages } from '../Utils/CloudCalls';

const AccountPage: React.FC = () => {
    const { user } = useAuth();
    const [avatar, setAvatar] = useState<string | null>(user?.avatar || null);
    const [firstName, setFirstName] = useState<string>(user?.first_name || '');
    const [lastName, setLastName] = useState<string>(user?.last_name || '');
    const [email, setEmail] = useState<string>(user?.email || '');
    const [phone, setPhone] = useState<string>(user?.phone || '');
    const [tabValue, setTabValue] = useState<number>(0);
    const isLoading = useSelector(userIsLoading);
    const tenantInfo: User[] = [user, user];

    const currentUserUnit = useSelector(currentUnit) as Unit;

    const updateFailed = useSelector(userError);
    const [imageFile, setImageFile] = useState<File | null>(null);
    const [deletedImage, setDeletedImage] = useState<string>('');
    const [alertInfo, setAlertInfo] = useState<{
        open: boolean;
        message: string;
        severity: 'info' | 'success' | 'error';
    }>({
        open: false,
        message: "",
        severity: 'info'
    });
    const dispatch = useDispatch();


    useEffect(() => {
        if (!currentUserUnit) {
            dispatch(Actions.fetchUnit.unitByUserActions.request({ user_id: user?.id }));
        }
    }, []);

    const handleCloseAlert = () => {
        setAlertInfo({ ...alertInfo, open: false });
    };

    const showAlert = (message: string, severity: 'info' | 'success' | 'error') => {
        setAlertInfo({ open: true, message, severity });
        setTimeout(() => {
            handleCloseAlert();
        }, 6000);
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (avatar?.startsWith('https://')) {
            const index = avatar.indexOf('/', avatar.indexOf('://') + 3) + 1;
            const imageName = avatar.slice(index);
            setDeletedImage(imageName);
        }

        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            setImageFile(file);
            setAvatar(URL.createObjectURL(file));
            event.target.value = '';
        }
    };

    const validateUpdate = () => {
        if (avatar === user?.avatar && firstName === user?.first_name && lastName === user?.last_name && email === user?.email && phone === user?.phone) {
            return false;
        }
        return true;
    };

    // const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    //     event.preventDefault();
    //     if (!validateUpdate()) {
    //         showAlert('No changes made', 'info');
    //         return;
    //     }
    //     if (deletedImage) {
    //         await deleteImage(deletedImage);
    //     }
    //     let imageUrl = avatar || '';
    //     if (imageFile) {
    //         imageUrl = (await uploadImage(imageFile)) || '';
    //         setAvatar(imageUrl);
    //     }
    //     dispatch(Actions.user.fetch.editUserActions.request(
    //         {user: { 
    //             _id: user?._id || '',
    //             firstName,
    //             lastName,
    //             email,
    //             phone,
    //             bio,
    //             avatar: imageUrl,
    //             isAdmin: user?.isAdmin || false,
    //         }}
    //     ));

    //     if (!isLoading && isEditSuccess) {
    //         showAlert('User updated successfully', 'success');
    //     } else if (!isLoading && !isEditSuccess && updateFailed) {
    //         showAlert('Error updating user', 'error');
    //     }
    // };

    const calculateCompletion = () => {
        let completion = 0;
        if (firstName) completion += 5;
        if (lastName) completion += 5;
        if (email) completion += 20;
        if (phone) completion += 20;
        if (avatar) completion += 10;
        return completion;
    };

    const theme = useTheme();

    const getPersonalInfo = () => {
        return (<Grid2 container spacing={2}>
            <Grid2 size={{xs: 12}}>
                <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                    <Grid container spacing={4}>
                        <Grid size={{xs: 12, sm: 4}} sx={{ textAlign: 'center' }}>
                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                <Avatar
                                    src={avatar || '/default-profile.png'}
                                    sx={{ width: 150, height: 150, mx: 'auto' }}
                                />
                                <CircularProgress
                                    variant="determinate"
                                    value={calculateCompletion()}
                                    size={150}
                                    thickness={1}
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        zIndex: 1,
                                    }}
                                />
                                <input
                                    accept="image/*"
                                    id="profile-pic-upload"
                                    type="file"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                />
                                <label htmlFor="profile-pic-upload">
                                    <IconButton
                                        component="span"
                                        sx={{
                                            position: 'absolute',
                                            bottom: 0,
                                            right: 0,
                                            zIndex: 2,
                                            bgcolor: theme.palette.background.paper,
                                        }}
                                    >
                                        <PhotoCameraIcon />
                                    </IconButton>
                                </label>
                            </Box>
                            <Typography variant="h5" sx={{ mt: 2 }}>
                                {firstName} {lastName}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 12, sm: 8}}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <TextField
                                    label="First Name"
                                    variant="outlined"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    disabled // Optional: you might want to enable this for editing
                                />
                                <TextField
                                    label="Last Name"
                                    variant="outlined"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    disabled // Optional: you might want to enable this for editing
                                />
                                <TextField
                                    label="Email"
                                    variant="outlined"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled // Optional: you might want to enable this for editing
                                />
                                <TextField
                                    label="Phone"
                                    variant="outlined"
                                    type="tel"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid2>
            <Grid2 size={{xs: 12}}>
                <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                    <Grid container spacing={4}>
                        <Grid size={{xs: 12, sm: 4}} sx={{ textAlign: 'center' }}>
                            <ContactEmergency sx={{mr:1, height: 200, width: 200}} color='primary' />
                            <Typography variant="h5" sx={{ mt: 2 }}>
                                Emergency Contact
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 12, sm: 8}}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <TextField
                                    label="Name"
                                    variant="outlined"
                                    value={user?.emergency_contact?.name || 'Information not available'}
                                    disabled // Optional: you might want to enable this for editing
                                />
                                <TextField
                                    label="Relationship"
                                    variant="outlined"
                                    value={user?.emergency_contact?.relationship || 'Information not available'}
                                    disabled // Optional: you might want to enable this for editing
                                />
                                <TextField
                                    label="Phone"
                                    variant="outlined"
                                    value={user?.emergency_contact?.phone || 'Information not available'}
                                    disabled // Optional: you might want to enable this for editing
                                />
                                <TextField
                                    label="Email"
                                    variant="outlined"
                                    value={user?.emergency_contact?.email || 'Information not available'}
                                    disabled // Optional: you might want to enable this for editing
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid2>
            <Grid2 size={{xs: 12}}>
                <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                    <Grid container spacing={4}>
                        <Grid size={{xs: 12, sm: 4}} sx={{ textAlign: 'center' }}>
                            <MeetingRoom sx={{mr:1, height: 200, width: 200}} color='primary' />
                            <Typography variant="h5" sx={{ mt: 2 }}>
                                Unit {currentUserUnit?.unit_number}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 12, sm: 8}}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <TextField
                                    label="Parking Spot"
                                    variant="outlined"
                                    value={currentUserUnit?.parking_slot || 'Information not available'}
                                    disabled // Optional: you might want to enable this for editing
                                />
                                <TextField
                                    label="Fob, Key, or Access Car"
                                    variant="outlined"
                                    value={currentUserUnit?.access_fob || 'Information not available'}
                                    disabled // Optional: you might want to enable this for editing
                                />
                                <TextField
                                    label="Buzzer Code"
                                    variant="outlined"
                                    value={currentUserUnit?.buzzer_code || 'Information not available'}
                                    disabled // Optional: you might want to enable this for editing
                                />
                                <TextField
                                    label="Locker"
                                    variant="outlined"
                                    value={currentUserUnit?.locker_number || 'Information not available'}
                                    disabled // Optional: you might want to enable this for editing
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid2>
        </Grid2>);
    }

    const accessInfo = () => {
        return (<Grid2 container spacing={2}>
            <Grid2 size={{xs: 12}}>
                <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                    <Grid container spacing={4}>
                        <Grid size={{xs: 12, sm: 4}} sx={{ textAlign: 'center' }}>
                            <LockOpen sx={{mr:1, height: 200, width: 200}} color='primary' />
                            <Typography variant="h5" sx={{ mt: 2 }}>
                                Access Information
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 12, sm: 8}}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Typography textAlign={'center'} fontWeight={600} variant="h5">Tenant Information</Typography>
                                <Grid2 container spacing={2}>
                                    {tenantInfo.map((tenant, index) => (
                                        <Grid2 size={{xs: 12, sm: 6}} key={index}>
                                            <UserCard key={index} user={tenant} />
                                        </Grid2>
                                    ))}
                                </Grid2>
                                {tenantInfo.length === 0 && <Paper elevation={3} sx={{borderRadius: 3, p:2}} ><Typography variant="subtitle1" fontWeight={600} color='text.secondary'>No tenants found</Typography></Paper>}
                                <Button variant="contained" sx={{ mt: 2}}>
                                    Add Tenant
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid2>
        </Grid2>);
    }

    return (
        <>
        <Paper elevation={5} sx={{mb: 2, padding: 3, borderRadius: 3}}>
            <Paper elevation={3} sx={{mb: 2, padding: 2, borderRadius: 3, display: 'flex', justifyContent: 'space-between'}}>
                <Box color='primary.main' sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', }}>
                    <Person sx={{mr:1, height: 40, width: 40}} />
                    <Typography variant="h5">Account</Typography>
                </Box>
            </Paper>
            <LoadingOverlay isLoading={isLoading} />
            <Snackbar open={alertInfo.open} autoHideDuration={6000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity={alertInfo.severity}>
                    {alertInfo.message}
                </Alert>
            </Snackbar>
            <Tabs
                value={tabValue}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                onChange={(event, newValue) => setTabValue(newValue)}
                sx={{mb: 2}}
            >
                <Tab label="General" />
                <Tab label="Access" />
                <Tab label="Preferences" />
            </Tabs>

            {tabValue === 0 && getPersonalInfo()}
            {tabValue === 1 && accessInfo()}
            {tabValue === 2 && <Typography variant="h5">Preferences</Typography>}

        </Paper>
        </>
    );
};

export default AccountPage;
